import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      height: 'unset',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-evenly',
      gap: theme.spacing(0.5),
      padding: theme.spacing(1.5, 1),
    },

    disabled: {
      '&:hover': {
        backgroundColor: 'unset',
        cursor: 'default',
      },
    },

    emptyState: {
      padding: theme.spacing(0, 2, 0),
      minHeight: 20,
      backgroundColor: 'unset',
      cursor: 'default',
      '&:hover': {
        backgroundColor: 'unset',
      },
      '& > p': {
        fontSize: theme.typography.pxToRem(12),
        lineHeight: theme.typography.pxToRem(20),
        color: COLORS.neutral.mediumGray,
      },
    },

    title: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(14),
      padding: theme.spacing(0, 0, 0, 1),
      backgroundColor: 'unset !important',
      minHeight: 20,
      cursor: 'default',
      '&:hover': {
        backgroundColor: 'unset',
      },
      '& p': {
        fontSize: theme.typography.pxToRem(12),
        lineHeight: theme.typography.pxToRem(14),
        color: COLORS.gray.gray40,
      },
    },
  }),
  { name: 'BaseMenuItem' }
);
